import $ from "jquery";
import language from "#scripts/translation";
export default function (metaData, overrideContact) {
    $.get(`//www.barnehagefakta.no/api/Barnehage/${metaData.enhetsId}`).done((data) => {
        const indikator = data.indikatorDataBarnehage;
        const kontakt = data.kontaktinformasjon;

        const barnehagefaktaHtml = `
                    ${data.eierform != null ? `<li>${data.eierform} barnehage</li>` : ""}
                    ${data.type != null ? `<li>${data.type}</li>` : ""}
                    ${(data?.oppfyllerPedagognorm === "Oppfyller pedagognormen") ? `<li>${data.oppfyllerPedagognorm}</li>` : ""}
                    ${data.alder != null ? `<li>${data.alder}</li>` : ""}
                    ${indikator.antallBarn != null ? `<li>Antall barn: ${indikator.antallBarn}</li>` : ""}
                    ${indikator.lekeOgOppholdsarealPerBarn != null ? `<li>Areal per barn: ${indikator.lekeOgOppholdsarealPerBarn} kvm </li>` : ""}
                    ${indikator.andelAnsatteBarnehagelarer != null ? `<li>Ansatte med barnehagelærerutdanning: ${indikator.andelAnsatteBarnehagelarer} %</li>` : ""}
                    ${indikator.antallBarnPerAnsatt != null ? `<li>Barn per ansatt: ${indikator.antallBarnPerAnsatt}</li>` : ""}
                    ${data.kostpenger != null ? `<li>Kostpenger: ${data.kostpenger},-</li>` : ""}
                    `;

        const barnehagefaktaAapningstider = `
                ${language("CONTACT_MONFRI")}: </br>${data.apningstidFra} - ${data.apningstidTil} 
           `;

        const barnehagefaktaKontakt = `
                <p>
                    ${language("CONTACT_PHONE")}:<br/> <a href="tel:${kontakt.telefon}">${kontakt.telefon}</a>
                </p>   
                <p>
                    ${language("CONTACT_EMAIL")}:<br/> <a href="mailto:${kontakt.epost}">${kontakt.epost}</a>
                </p>   
                <p>
                    ${language("CONTACT_VISITTADDRESS")}:</br>
                    ${kontakt.besoksAdresse.adresselinje}, 
                    ${kontakt.besoksAdresse.postnr} 
                    ${kontakt.besoksAdresse.poststed}
                    <br/><a href="https://www.google.com/maps/place/${kontakt.besoksAdresse.adresselinje}+${kontakt.besoksAdresse.postnr}+${kontakt.besoksAdresse.poststed}/" aria-label="${language("CONTACT_SEEMAP")} (${language("NAV_OPEN_I_NEW")})" target=_blank>${language("CONTACT_SEEMAP")}</a>
                </p>
           `;

        let barnehagefaktaMener = "";

        if (indikator.foreldreundersokelsenArgang) {
            barnehagefaktaMener = `
           <div class="table-responsiv">
                <table class="table">
                    <thead class="thead-dark">
                        <tr>
                            <th></th>
                            <th>${indikator.foreldreundersokelsenArgang}</th>
                        </tr>
                    </thead>    
                    <tbody>
                        <tr>
                            <td>${language("BF_ANSWERPART")}</td>
                            <td>${indikator.foreldreundersokelsenSvarprosent} %</td>
                        </tr>
                        <tr>
                            <td>${language("BF_OUTNIN")}</td>
                            <td>${indikator.foreldreundersokelsenUteOgInneMiljo}</td>
                        </tr>
                        <tr>
                            <td>${language("BF_CHILDOK")}</td>
                            <td>${indikator.foreldreundersokelsenBarnetsTrivsel}</td>
                        </tr>
                        <tr>
                            <td>${language("BF_INFORMATION")}</td>
                            <td>${indikator.foreldreundersokelsenInformasjon}</td>
                        </tr>
                        <tr>
                            <td>${language("BF_CHILDDEV")}</td>
                            <td>${indikator.foreldreundersokelsenBarnetsUtvikling}</td>
                        </tr>
                        <tr>
                            <td>${language("BF_TOTALOK")}</td>
                            <td>${indikator.foreldreundersokelsenTilfredshet}</td>
                        </tr>
                    </tbody>
                </table>
                <sub>Kilde: barnehagefakta.no</sub>
           </div>`;
        }

        let contactHtml = `
            <div class="article__keyinfo">
                <h2>${language("CONTACT_CONTACT")}</h2>
                <div id="barnehagefakta-kontakt"></div>
            </div>`;

        if (overrideContact) {
            contactHtml = overrideContact;
        }

        $("#barnehagefakta_rightcolumn").html(`
            <div class="article__keyinfo">
                <h2>${language("BF_KEYINFO")}</h2>
                <ul id="barnehagefakta-nokkel"></ul>
                <sub>Kilde: barnehagefakta.no</sub>
            </div>
            ${contactHtml}
            <div class="article__keyinfo">
                <h2>${language("BF_OPENHOUR")}</h2>
                <p id="barnehagefakta-aapningstider"></p>
            </div>`);

        $("#barnehagefakta-nokkel").append(barnehagefaktaHtml);
        $("#barnehagefakta-aapningstider").append(barnehagefaktaAapningstider);
        $("#barnehagefakta-kontakt").append(barnehagefaktaKontakt);
        $("#barnehagefakta-opinion").append(barnehagefaktaMener);
    });

    return `
        <div class="article" id="barnehagefakta_rightcolumn">
        </div>`;
}
